import SiteHeader from "@/components/common/SiteHeader";
import { createFileRoute } from "@tanstack/react-router";
import React, { Suspense, lazy } from "react";

// Wave-17 Item 1.1 — ConnectRewire page lazy-loaded.
const ConnectRewire = lazy(() => import("@/pages/ConnectRewire/Page"));

const ConnectRewireRoute = () => (
  <div className="flex flex-col w-full">
    <SiteHeader header="Connect Carbon Clear" />
    <Suspense fallback={null}>
      <ConnectRewire />
    </Suspense>
  </div>
);

export const Route = createFileRoute("/connect_rewire")({
  component: ConnectRewireRoute,
  validateSearch: (search: Record<string, unknown>) => ({
    rewireId: search.rewireId as string,
  }),
});
